// extracted by css-extract-rspack-plugin
export default {"PieChartWrapper":"_u0pl","Summary":"vile_"};